const isTestMode = () =>
  process.env.NODE_ENV !== 'production' &&
  isTestDomain(window.location.hostname);

const isTestDomain = (domain: string) =>
  ['localtest.me'].some((value) => domain.endsWith(value));

export default isTestMode;
